import './object-define-property.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var defineProperty = objectDefineProperty.f;

var proxyAccessor = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

export { proxyAccessor as p };
